// Text Align extension (JS port)
// Mirrors the Vuetify-Pro setup: injects a dropdown button and defaults types
import { TextAlign as TiptapTextAlign } from '@tiptap/extension-text-align'
import { TextAlignActionMenuButton } from '@/tiptap/extensions/components/ActionMenuButton'

// Allowed values (for reference in our codebase)
// 'left' | 'center' | 'right' | 'justify'

const TextAlign = TiptapTextAlign.extend({
  addOptions() {
    const parent = typeof this.parent === 'function' ? this.parent() : {}
    return {
      ...parent,
      // match the demo: align headings & paragraphs
      types: ['heading', 'paragraph'],
      // menu button wiring
      button: ({ editor, extension, t }) => ({
        component: TextAlignActionMenuButton,
        componentProps: { editor, extension, t }
      })
    }
  }
})

export default TextAlign